document.addEventListener('DOMContentLoaded', () => {
  if (window.videoStoriesInitialized) return;
  window.videoStoriesInitialized = true;

  const previewVideos = document.querySelectorAll('video[data-deferred-autoplay]');
  const previewVideoObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            video.dataset.videoInView = entry.isIntersecting ? 'true' : 'false';
            if (entry.isIntersecting && !document.hidden) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: '160px 0px' }
      )
    : null;

  previewVideos.forEach((video) => {
    if (previewVideoObserver) {
      previewVideoObserver.observe(video);
    } else {
      video.play().catch(() => {});
    }
  });

  document.addEventListener('visibilitychange', () => {
    previewVideos.forEach((video) => {
      if (document.hidden) {
        video.pause();
      } else if (video.dataset.videoInView === 'true') {
        video.play().catch(() => {});
      }
    });
  });

  const getModalForButton = (button) => {
    const section = button.closest('.shopify-section');
    return section?.querySelector('.video-stories-modal') || document.querySelector('.video-stories-modal');
  };

  let modal = null;
  let modalContent = null;
  let muteBtn = null;
  let iconMuted = null;
  let iconUnmuted = null;

  const bindModal = (button) => {
    modal = getModalForButton(button);
    if (!modal) return false;

    modalContent = modal.querySelector('.video-stories-modal__video-container');
    muteBtn = modal.querySelector('.video-stories-modal__mute');
    iconMuted = muteBtn ? muteBtn.querySelector('.icon-muted') : null;
    iconUnmuted = muteBtn ? muteBtn.querySelector('.icon-unmuted') : null;
    return Boolean(modalContent);
  };


  let currentVideoElement = null;
  let activeTrigger = null;

  function updateMuteIcon(isMuted) {
    if (!iconMuted || !iconUnmuted) return;
    if (isMuted) {
      iconMuted.classList.remove('hidden');
      iconUnmuted.classList.add('hidden');
    } else {
      iconMuted.classList.add('hidden');
      iconUnmuted.classList.remove('hidden');
    }
  }

  // Abrir Modal via Delegação
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.video-stories__button, [data-video-trigger]');
    if (!button || !bindModal(button)) return;

    e.preventDefault();
    activeTrigger = button;

    const videoUrl = button.dataset.videoUrl;
    const videoType = button.dataset.videoType;
    const shopifyVideoSrc = button.dataset.shopifyVideoSrc;
    const shopifyVideoType = button.dataset.shopifyVideoType || 'video/mp4';
    const customVideoUrl = button.dataset.customVideoUrl;

    let contentHTML = '';

    // Mostrar botão de mudo apenas para vídeos nativos (MP4)
    if (muteBtn) {
      muteBtn.style.display = (videoType === 'shopify' || videoType === 'custom') ? 'flex' : 'none';
    }

    if (videoType === 'shopify' && shopifyVideoSrc) {
      // Vídeo Shopify: iniciar com som
      contentHTML = `
        <video autoplay playsinline loop class="story-video">
          <source src="${shopifyVideoSrc}" type="${shopifyVideoType}">
          Seu navegador não suporta o elemento de vídeo.
        </video>
      `;
      updateMuteIcon(false);
    } else if (videoType === 'custom' && customVideoUrl) {
      // Link MP4 direto: iniciar com som
      contentHTML = `
        <video autoplay playsinline loop class="story-video">
          <source src="${customVideoUrl}" type="video/mp4">
          Seu navegador não suporta o elemento de vídeo.
        </video>
      `;
      updateMuteIcon(false);
    } else if (videoType === 'youtube' && videoUrl) {
      // YouTube
      const ytMatch = videoUrl.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/shorts\/))([a-zA-Z0-9_-]{10,12})/);
      if (ytMatch) {
        const videoId = ytMatch[1];
        contentHTML = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&loop=1&mute=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      }
    } else if (videoType === 'vimeo' && videoUrl) {
      // Vimeo
      const vimeoMatch = videoUrl.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) {
        const videoId = vimeoMatch[1];
        contentHTML = `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&muted=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      }
    } else if (videoUrl) {
      // Fallback: tratar como MP4 direto
      if (muteBtn) muteBtn.style.display = 'flex';
      contentHTML = `
        <video autoplay playsinline loop class="story-video">
          <source src="${videoUrl}">
          Seu navegador não suporta o elemento de vídeo.
        </video>
      `;
      updateMuteIcon(false);
    }

    if (!contentHTML) return;

    modalContent.innerHTML = contentHTML;
    modal.setAttribute('aria-hidden', 'false');
    activeTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.video-stories-modal__close')?.focus({ preventScroll: true });

    // Capturar elemento de vídeo para controle de mudo
    currentVideoElement = modalContent.querySelector('video');

    // Para vídeos nativos, tentar reproduzir com som
    if (currentVideoElement) {
      currentVideoElement.muted = false;
      currentVideoElement.play().catch(() => {
        // Autoplay com som bloqueado pelo navegador — fallback para mudo
        currentVideoElement.muted = true;
        currentVideoElement.play();
        updateMuteIcon(true);
      });
    }
  });

  // Fechar Modal
  function closeModal() {
    if (!modal || !modalContent) return;
    modal.setAttribute('aria-hidden', 'true');
    modalContent.innerHTML = '';
    document.body.style.overflow = '';
    currentVideoElement = null;
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus();
      activeTrigger = null;
    }
  }

  document.addEventListener('click', (e) => {
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;

    if (e.target.closest('.video-stories-modal__close') || e.target.classList.contains('video-stories-modal__backdrop')) {
      closeModal();
      return;
    }

    const clickedMute = e.target.closest('.video-stories-modal__mute');
    if (clickedMute && currentVideoElement) {
      e.stopPropagation();
      currentVideoElement.muted = !currentVideoElement.muted;
      updateMuteIcon(currentVideoElement.muted);
    }
  });

  // Fechar com tecla Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal?.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
});
